import { recordApi, recordError } from './buffers';

/** En-tête de corrélation posé par le backend sur chaque réponse. */
export const REQUEST_ID_HEADER = 'x-request-id';

/**
 * Trace un appel API dans les anneaux : une miette `api` (métadonnées HTTP) et,
 * si le statut est une erreur (≥ 400), une entrée d'erreur de source `api`. À
 * appeler autour de CHAQUE requête dans la couche HTTP.
 */
export function traceApi(
  method: string,
  path: string,
  status: number,
  ms: number,
  requestId: string | null,
): void {
  recordApi({ method, path, status, ms, requestId });
  if (status >= 400) {
    const ref = requestId ? ` [${requestId}]` : '';
    recordError(`${method} ${path} → ${status}${ref}`, 'api');
  }
}

/** Lit l'en-tête `x-request-id` d'une réponse (corrélation avec les logs serveur). */
export function requestIdOf(res: Response): string | null {
  try {
    return res.headers.get(REQUEST_ID_HEADER);
  } catch {
    return null;
  }
}

/** Horloge monotone si disponible (sinon `Date.now`), pour mesurer une durée. */
export function nowMs(): number {
  if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
    return performance.now();
  }
  return Date.now();
}
